const DEFAULT_PAGE_SIZE = 10;

type GetPageResult<Data> = {
  pageCount: number;
  currentPage: number;
  pageItems: Data[];
};

export const getPage = <Data>(
  items: Data[],
  page: number,
  pageSize: number = DEFAULT_PAGE_SIZE,
): GetPageResult<Data> => {
  const pageCount = Math.max(1, Math.ceil(items.length / pageSize));
  const currentPage = Math.min(page, pageCount);
  const pageItems = items.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  return { pageCount, currentPage, pageItems };
};
